'use client';

import HeaderShopCart from '@/components/header/header-shop-cart';
import classes from '@/components/header/header.module.scss';
import LanguageSelect from '@/components/header/language-select';
import LoginOrNicknameButton from '@/components/header/login-or-nickname-button';
import { useDictionary } from '@/lib/context/locale-provider';
import { StoreProvider } from '@/lib/context/store-provider';
import { Languages } from '@/lib/dictionaries';
import { parseJwt } from '@/lib/parse-jwt';
import { signIn, useSession } from 'next-auth/react';
import { usePathname, useRouter } from 'next/navigation';
import React, { useEffect, useState } from 'react';

function GlobalNavigation({
  lang,
  accessToken,
}: {
  lang: Languages;
  accessToken: string;
}) {
  const dict = useDictionary();
  const session = useSession();

  const router = useRouter();
  const pathname = usePathname() || '/';

  const [viewMGNB, setViewMGNB] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<string | null>(null);

  const handleOpenGNB = () => {
    setViewMGNB(true);
  };

  const handleCloseGNB = () => {
    setViewMGNB(false);
  };

  const goLink = (link: string) => {
    setViewMGNB(false);
    router.push(link);
  };

  useEffect(() => {
    if (pathname.includes('/my')) {
      setCurrentPage('my');
    } else if (pathname.includes('/ad')) {
      setCurrentPage('ad');
    } else if (pathname.includes('/sign')) {
      setCurrentPage('auth');
    } else {
      setCurrentPage('shop');
    }
  }, [pathname]);

  useEffect(() => {
    async function appSignIn(userId: string) {
      const res = await signIn('credentials', {
        userId: userId,
        redirect: false,
      });

      document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

      if (res && !res.ok) {
        router.replace(`/${lang}?refresh=${Date.now()}`);
        // APP 넘어왔는데 로그인 정보가 일치하지 않는 경우
      }
    }

    if (accessToken !== '') {
      const parsedToken = parseJwt(accessToken);
      if (parsedToken.user_group === 'member' && parsedToken.user) {
        if (
          session.data === null ||
          parsedToken.user !== session.data?.user.userId
        ) {
          appSignIn(parsedToken.user);
        }
      }
    }
  }, [accessToken, session]);

  return (
    <>
      <div
        className={`${classes.headerNav} ${viewMGNB ? classes.isActive : ''}`}
      >
        <div className={classes.navWrap}>
          <button
            className={classes.navCloseBtn}
            onClick={handleCloseGNB}
          ></button>
          <nav className={classes.headerGnb}>
            <ul>
              <li>
                <button
                  className={`${classes.gnbBtn} ${currentPage === 'shop' ? classes.txtGradient : undefined}`}
                  onClick={() => goLink(`/${lang}/`)}
                >
                  {dict!.header.giftifanShop}
                </button>
              </li>
              {session !== null &&
                session.status === 'authenticated' &&
                session.data.user &&
                session.data.user.userId && (
                  <li>
                    <button
                      className={`${classes.gnbBtn} ${currentPage === 'my' ? classes.txtGradient : undefined}`}
                      onClick={() => goLink(`/${lang}/my/home`)}
                    >
                      {dict!.header.mypage}
                    </button>
                  </li>
                )}
            </ul>
          </nav>
          <div className={classes.headerOption}>
            <StoreProvider>
              <LoginOrNicknameButton
                lang={lang}
                loginButtonName={dict!.login.loginButtonName}
                logoutButtonName={dict!.login.logoutButtonName}
              />
              <LanguageSelect lang={lang} />
            </StoreProvider>
          </div>
        </div>
      </div>
      <div className={classes.headerMenu}>
        <StoreProvider>
          <HeaderShopCart className="" useIcon={true} lang={lang} />
        </StoreProvider>
        <button className={classes.headerMenuBtn} onClick={handleOpenGNB}>
          <i className={`${classes.ic} ${classes.icGnb}`}></i>
        </button>
      </div>
    </>
  );
}

export default GlobalNavigation;
